import React, { useState } from 'react';
import {
  Button,
  Container,
  FormControl,
  InputLabel,
  Box,
  Modal,
  MenuItem,
  Select,
  TextField,
  Typography,
  Paper,
  Tooltip
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AddDesignation = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [departmentId, setDepartmentId] = useState('');
  const [designationName, setDesignationName] = useState('');
  const navigate = useNavigate();

  // Static data for departments
  const staticDepartmentData = [
    { deptId: 1, departmentName: 'Administration' },
    { deptId: 2, departmentName: 'Finance' },
    { deptId: 3, departmentName: 'IT' },
    { deptId: 4, departmentName: 'Management' },
    { deptId: 5, departmentName: 'Marketing' },
  ];

  const handleSave = (e) => {
    e.preventDefault();
    if (departmentId && designationName) {
      setShowSuccessModal(true);
    } else {
      alert('Please fill all fields');
    }
  };

  const handleCancel = () => {
    setDepartmentId('');
    setDesignationName('');
  };

  return (
    <Container>
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)',
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '0 auto',
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Add Designation
        </Typography>
      </Box>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6, backgroundColor: '#f8fdfeff' }}>
        <div>
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel id="department-label">Department</InputLabel>
            <Select
              labelId="department-label"
              id="department"
              autoFocus
              value={departmentId}
              label="Department"
              onChange={(e) => setDepartmentId(e.target.value)}
            >
              {staticDepartmentData.map((department) => (
                <MenuItem key={department.deptId} value={department.deptId}>
                  {department.departmentName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Designation Name"
            variant="outlined"
            fullWidth
            value={designationName}
            onChange={(e) => setDesignationName(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!departmentId ? "Select Department" : !designationName ? "Enter Designation Name" : ""} arrow>
            <span>
              <Button
                variant="contained"
                onClick={handleSave}
                sx={{
                  mr: 2,
                  backgroundColor: '#127498ff',
                  '&:hover': { backgroundColor: '#116280ff' }
                }}
                disabled={!departmentId || !designationName}
              >
                SAVE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            RESET
          </Button>
        </div>
      </Paper>
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Designation Added ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Designation Added Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default AddDesignation;
